import { observer } from 'mobx-react'
import React, { Component } from 'react'
import ApiKeyStore from './ApiKeyStore'

import './apiKey.scss'
import DataTable from '../../../DataTable'
import Panel from '../../../../UniformComponents/Panel'

@observer
class ApiKeys extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.apiKeyStore = new ApiKeyStore(store)
        this.apiKeyStore.setTableColumns()
    }

    componentDidMount() {
        const { store } = this.props
        this.apiKeyStore.getApiKeysData()
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'apiKey',
                url: '/intranet/apiKey',
                title: 'Benchmark Jobs',
            },
        ]
    }

    renderTable = () => {
        const { data, columns } = this.apiKeyStore
        return (
            <DataTable
                store={{ filteredList: data }}
                dataSet={data}
                columns={columns}
            />
        )
    }

    render() {
        return (
            <Panel id="apiKeys">
                <div>
                    <h2>API Keys</h2>
                </div>

                <div style={{ display: 'flex' }}>
                    {this.renderTable()}
                </div>
            </Panel>
        )
    }
}
export default ApiKeys
